import urn from '@widesk-core/decorators/urn';

export default (resource: string) => (target: any) => urn(target.partitionName || '$', target.serviceName, resource)(target);
